import React, {useContext, useState, useEffect} from 'react';
import {withRouter, useParams} from 'react-router-dom';
import Nav from '../components/nav/Nav';
import Sidebar from '../components/Sidebar';
import "../styles/home.scss";
import {GlobalContext} from "../context/GlobalState";
import Table from "../components/notes/Table";
import usersApi from "../services/api/users";
import Toolbar from '../components/Toolbar';
let isNewFolder = true;

const Home = ({history}) => {
  const {folder} = useParams();
  let limit = 50;
  let timesLoaded = 0;
  const {userData} = useContext(GlobalContext);
  const [lastCreated, setLastCreated] = useState(+new Date());
  const [videos, setVideos] = useState([]);
  const [folders, setFolders] = useState([]);
  const [previousFolder, setPreviousFolder] = useState('');
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [loadMore, setLoadMore] = useState(false);
  const [isEnd, setIsEnd] = useState(false);

  const getNotes = async () => {
    timesLoaded++;
    const {data} = await usersApi.getNotes({
      folder,
      limit,
      lastCreated: isNewFolder ? +new Date() : lastCreated,
    });
    if (isNewFolder) {
      setFolders(data.folders);
      setVideos(data.videos);
      setPreviousFolder(data.previousFolder);
    } else {
      setVideos({...videos, ...data.videos});
    }

    setLastCreated(data.lastCreated);
    setIsEnd(data.isEnd);
    setIsLoading(false);
    setLoadMore(false);
    isNewFolder = false;

    if (videos.length + folders.length < 5 && !isEnd && timesLoaded < 3) {
      setLoadMore(true);
      limit += 50;
      await getNotes();
    }
  };

  const selectVideo = key => {
    setSelectedVideo(key);
  };

  const updatePreviousFolder = folderToAdd => {
    setPreviousFolder(folderToAdd);
  };

  const handleScrollEnd = async e => {
    const bottom = e.target.scrollHeight - e.target.scrollTop <= e.target.clientHeight + 300;

    if (bottom && !loadMore && !isEnd) {
      setLoadMore(true);
      await getNotes();
    }
  };

  useEffect(() => {
    isNewFolder = true;
    setIsLoading(true);
    getNotes();
  }, [folder]);

  useEffect(() => {
    if (!userData || !userData.accountLevel) {
      history.push('/login')
    }
  }, [userData]);

  const folderColumns = React.useMemo(
    () => [
      {
        Header: 'Name',
        accessor: 'name'
      },
      {
        Header: 'Modified',
        accessor: 'updatedAt'
      },
    ]
  );

  return (
      <div className='main'>
        <div className='content'>
          <Nav/>
            <Toolbar/>
            <div className='content-main'>
                <Table
                  folder={folder}
                  previousFolder={previousFolder}
                  columns={folderColumns}
                  folders={folders}
                  videos={videos}
                  selectVideo={selectVideo}
                  isLoading={isLoading}
                  setPreviousFolder={updatePreviousFolder}
                  handleScrollEnd={handleScrollEnd}
                  loadMore={loadMore}
                />
            </div>
        </div>
        <div className={`sidebar-background ${selectedVideo && 'video-selected'}`} onClick={() => setSelectedVideo(null)} />
        <Sidebar selectedVideo={selectedVideo} videos={videos} />
      </div>
  );
};

export default withRouter(Home);
